import { createAsyncThunk } from "@reduxjs/toolkit";
import { SessionSearchResultResponse } from "../contracts/SessionSearchResultResponse";
import { MemberSearchResultResponse } from "../contracts/MemberSearchResultResponse";
import { SessionSearchResult } from "../models/SessionSearchResult";
import { MemberSearchResult } from "../models/MemberSearchResult";
import { SearchResponseMapper } from "../mappers/SearchResponseMapper";
import { ApiErrorResponse } from "../../../api/types/ApiErrorResponse";
import { toApiError } from "../../../api/utils/errorHandling";
import axiosInstance from "../../axiosInstance/axiosInstance";

const mapper = new SearchResponseMapper();

const RESULTS_PER_CATEGORY = 5;

export interface GlobalSearchResults {
  sessions: SessionSearchResult[];
  members: MemberSearchResult[];
}

/**
 * Async thunk for the header's global search: queries sessions and members in
 * parallel and returns both suggestion lists.
 */
export const fetchSearchResults = createAsyncThunk<
  GlobalSearchResults,
  string,
  { rejectValue: ApiErrorResponse }
>("search/fetchSearchResults", async (query, { rejectWithValue }) => {
  try {
    const params = { query, limit: RESULTS_PER_CATEGORY };
    const [sessionsResponse, membersResponse] = await Promise.all([
      axiosInstance.get<SessionSearchResultResponse[]>("/bookings/search", { params }),
      axiosInstance.get<MemberSearchResultResponse[]>("/members/search", { params }),
    ]);

    return {
      sessions: sessionsResponse.data.map((r) => mapper.toSessionSearchResult(r)),
      members: membersResponse.data.map((r) => mapper.toMemberSearchResult(r)),
    };
  } catch (error: unknown) {
    return rejectWithValue(toApiError(error, "Failed to search"));
  }
});
